import RankingCell from "./CellComponents/RankingCell"
import InstrumentNameCellToDetailPage from "./CellComponents/InstrumentNameCellToDetailPage"
import InstrumentNameCellToDetailDialog from "./CellComponents/InstrumentNameCellToDetailDialog"
import CountryFlagCell from "./CellComponents/CountryFlagCell"
import InstrumentCurrencyCell from "./CellComponents/InstrumentCurrencyCell"
import PercentageChangeCell from "./CellComponents/PercentageChangeCell"
import PercentageCell from "./CellComponents/PercentageCell"
import ActionsMenuCell from "./CellComponents/ActionsMenuCell"
import ActionsButtonsCell from "./CellComponents/ActionsButtonsCell"
import DebugCell from "./CellComponents/DebugCell"
import DateCell from "./CellComponents/DateCell"
import NumberValueCell from "./CellComponents/NumberValueCell"
import LinkCell from "./CellComponents/LinkCell"
import AbsoluteAndPercentageCell from "@/components/common/DataTable/CellComponents/AbsoluteAndPercentageCell"
import AssetClassFinder from "@/components/pages/onboarding/AssetClassFinder"
import IconCell from "@/components/common/DataTable/CellComponents/IconCell"
import {currencyFilter} from "@/plugins/fincraft"
import DynamicRendererCell from "@/components/common/DataTable/CellComponents/DynamicRendererCell"
import TextCell from "@/components/common/DataTable/CellComponents/TextCell"


const CASHFLOWREQUENCIES = {
  H: 'Halbjährlich',
  M: 'Monatlich',
  Y: 'Jährlich',
  Q: 'Vierteljährlich',
  D: null
}

const TRANSACTIONICONS = {
  'SELL': {value: 'mdi-playlist-minus', tooltip: 'Verkauf', tooltipPosition: 'left'},
  'BUY': {value: 'mdi-playlist-plus', tooltip: 'Kauf', tooltipPosition: 'left'},
  'CASH_PAY_IN': {value: 'mdi-bank-plus', tooltip: 'Einzahlung', tooltipPosition: 'left'},
  'CASH_PAY_OUT': {value: 'mdi-bank-minus', tooltip: 'Auszahlung', tooltipPosition: 'left'},
  'SPLIT': {value: 'mdi-call-split', tooltip: 'Split', tooltipPosition: 'left'},
  'DIVIDEND': {value: 'mdi-sack-percent', tooltip: 'Dividende', tooltipPosition: 'left'}
}

const HINTS = {
  CURRENTBUSINESSYEAR: {
    key: 'CURRENTBUSINESSYEAR',
    text: 'Auf Basis des laufenden Geschäftsjahres'
  },
  CURRENTBUSINESSYEARESTIMATE: {
    key: 'CURRENTBUSINESSYEARESTIMATE',
    text: 'Auf Basis der Prognose des laufenden Geschäftsjahres u. d. Vortagesschlußkurs'
  }
}

const getHeaderKey = function (header, index) {
  return header.dynamicModel ? (header.dynamicModelKey || 'computed_' + index) : header.value
}

const adaptHeader = function (headers) {
  //auto path headers, TODO improve (move to table)
  return headers.map((header, index) => {
    const result = {
      ...header,
    }
    if (!result.adapted) {
      result.adapted = true
      result.path = header.value
      result.value = getHeaderKey(header, index)
    }
    return result
  })
}


class HeaderBuilder {
  constructor(parent, path) {
    this.propPath = (prop) => (path || '') + ((path && prop) ? '.' : '') + (prop || '')
    this._headers = parent?._headers || []
    this._parent = parent
  }

  parent() {
    if (!parent) {
      throw "Builder is root"
    }
    return this._parent
  }

  get(mobileView) {
    if (mobileView) {
      return {
        headers: adaptHeader(this._headers),
        mobileView
      }
    }
    return adaptHeader(this._headers)
  }

  add(headers) {
    if (headers) {
      headers = Array.isArray(headers) ? headers : [headers]
      headers.forEach(header => {
          if (header.lookupValues) {
            this.createLookupValue(header.text, header.value, header)
          } else if (header.type) {
            // console.log("VL header", header)
            if (header.type === 'RATIO') {
              this.createRatio(header.text, header.value, header)
            } else if (header.type === 'PERCENT') {
              this.createPercentageChange(header.text, header.value, header)
            } else if (header.type === 'CURRENCY') {
              this.createCurrencyValue(header.text, header.value, header)
            } else if (header.type === 'NUMBER') {
              this.createNumberValue(header.text, header.value, header)
            } else if (header.type === 'DATE') {
              this.createDateValue(header.text, header.value, header)
            } else if (header.type === 'COUNTRY') {
              this.createCountryFlag(header.text, header.value, {autoCol: true, ...header}).adapt({sortKey: header.itemId})
            } else if (header.type === 'SCORE') {
              this.createRanking(header.text, header.value, {class: 'finScore', autoCol: true, ...header})
            }
            // special handling for etf screener sector => show the text from sectorTopic
            else if (header.type === 'SECTOR' && header.value === "shareEtfSector") {
              this.createTextValue(header.text, 'sectorTopic', header).adapt({value: 'sectorTopic'})
            }
            // special handling for etf screener (commodities) fundNicheCode => show the text from fundNiche
            else if (header.type === 'TEXT' && header.value === "fundNicheCode") {
              this.createTextValue(header.text, 'fundNiche', header).adapt({value: 'fundNiche'})
            } else {
              this.createTextValue(header.text, header.value, header)
            }
          } else {
            this._headers.push(header)
          }
        }
      )
    }

    return this
  }

  debug(name = "Debug") {
    this._headers.push({
      text: name,
      align: 'left',
      value: 'debug.' + name,
      sortable: true,
      noValue: true,
      component: DebugCell,
    })
    return this
  }

  adapt(custom) {
    const index = this._headers.length - 1
    this._headers[index] = {
      ...this._headers[index],
      ...custom,
    }
    return this
  }

  adaptAll(custom) {
    this._headers = this._headers.map(header => ({
      ...header,
      ...custom,
    }))
    return this
  }

  createByItem(item) {
    const {id, itemId, shortName, unit, lookupValues, sortable = true, tablePath, tableOrder } = item
    return this.add({
      text: shortName,
      type: unit,
      value: tablePath ? tablePath : id,
      itemId: itemId,
      lookupValues,
      sortable,
      sortKey: tableOrder ? tableOrder : itemId
    })
  }

  createByItems(items) {
    if (items) {
      items.forEach(item => this.createByItem(item))
    }
    return this
  }

  /** Creates a spacer, the width is dependend from the remaining space */
  createSpacer() {
    this._headers.push({
      align: 'center',
      sortable: false,
      noValue: true,
      value: 'spacer'
    })
    return this
  }

  createLookupValue(name, prop, custom) {
    this._headers.push({
      text: name,
      keywordSort: true,
      sortable: true,
      sortKey: this.propPath(prop),
      align: 'left',
      width: 120,
      value: this.propPath(prop),
      component: TextCell,
      componentProps: {
        customStyling: 'font-weight: normal;'
      },
      dynamicModel: (item) => {
        return custom.lookupValues.find(lv => lv.id === item)?.name || custom.lookupValues.find(lv => lv.id === 'noValue')?.name || '-'
      },
      dynamicModelKey: 'col_lookup_' + prop,
      ...custom,
    })
    return this
  }

  /** Creates a circular progress, displaying the given number usable e.g. for displaying the finScore */
  createRanking(name, prop, custom) {
    this._headers.push({
      text: name,
      sortable: true,
      value: this.propPath(prop),
      align: 'center',
      width: 100,
      component: RankingCell,
      ...custom,
    })
    return this
  }

  /** Creates a visual representation of the +- percentage change */
  createPercentageChange(name, prop, custom) {
    this._headers.push({
      text: name,
      align: 'right',
      sortable: true,
      width: 120,
      component: PercentageChangeCell,
      componentProps: {
        inPercent: true
      },
      value: this.propPath(prop),
      ...custom,
    })
    return this
  }

  createPercentage(name, prop, custom) {
    this._headers.push({
      text: name,
      align: 'right',
      sortable: true,
      width: 120,
      component: PercentageCell,
      componentProps: {
        inPercent: true
      },
      value: this.propPath(prop),
      ...custom,
    })
    return this
  }

  createRatio(name, prop, custom) {
    return this.createNumberValue(name, prop, custom)
  }

  createTextValue(name, prop, custom) {
    this._headers.push({
      text: name,
      keywordSort: true,
      sortable: true,
      align: 'left',
      width: 120,
      value: this.propPath(prop),
      ...custom,
    })
    return this
  }

  createLinkValue(name, prop, custom) {
    this._headers.push({
      text: name,
      keywordSort: true,
      sortable: true,
      align: 'left',
      width: 120,
      component: LinkCell,
      value: this.propPath(prop),
      ...custom,
    })
    return this
  }

  /** Creates a visual representation of a formatted number */
  createNumberValue(name, prop, custom) {
    this._headers.push({
      text: name,
      sortable: true,
      align: 'right',
      component: NumberValueCell,
      width: 120,
      value: this.propPath(prop),
      ...custom,
    })
    return this
  }

  /** Creates a currency display, optionally showing a formatted date + additional icon via custom config */
  createCurrencyValue(name, prop, custom) {
    this._headers.push({
      text: name,
      sortable: true,
      align: 'right',
      width: 86,
      component: InstrumentCurrencyCell,
      value: this.propPath(prop),
      ...custom,
    })
    return this
  }

  /** Creates an icon with the country flag */
  createCountryFlag(name, prop, custom) {
    this._headers.push({
      text: name,
      width: 100,
      sortable: true,
      keywordSort: true,
      value: this.propPath(prop),
      align: 'center',
      sortKey: this.propPath('country.name'),
      component: CountryFlagCell,
      ...custom
    })
    return this
  }

  /** Creates a visual representation of a formatted number */
  createDateValue(name, prop, custom) {
    this._headers.push({
      text: name,
      sortable: true,
      value: this.propPath(prop),
      align: 'right',
      component: DateCell,
      width: 120,
      ...custom
    })
    return this
  }

  createIconCell(name, prop, custom) {
    this._headers.push({
      text: name,
      value: this.propPath(prop),
      align: 'center',
      width: 10,
      sortable: false,
      component: IconCell,
      componentProps: {},
      ...custom,
    })
    return this
  }

  /** Creates a two line col displaying the absolute value as currency and a percentage */
  createAbsoluteAndPercentage(name, prop, custom) {
    this._headers.push({
      align: 'right',
      text: name,
      sortable: true,
      value: this.propPath(prop),
      width: 1,
      component: AbsoluteAndPercentageCell,
      ...custom
    })
    return this
  }

  /** Adds a column for custom actions, use the #item.actions slot */
  actionsCell() {
    this._headers.push({
      text: '',
      align: 'right',
      value: 'actions',
      width: 10,
      sortable: false,
      noValue: true,
    })
    return this
  }

  /** Adds a v-menu with 3 vertical dots, actions is an array of objects containing name, icon, click function */
  actionsMenu(actions) {
    this._headers.push({
      text: 'Aktion',
      align: 'right',
      value: 'actionsMenu',
      width: 10,
      sortable: false,
      noValue: true,
      autoCol: true,
      component: ActionsMenuCell,
      componentProps: {
        actions
      }
    })
    return this
  }

  /** Adds one or more buttons, actions is an array of objects containing name, icon, click function */
  actionsButtons(actions) {
    if (actions) {
      this._headers.push({
        text: '',
        align: 'right',
        value: 'actionsButtons',
        width: 10,
        sortable: false,
        noValue: true,
        component: ActionsButtonsCell,
        componentProps: {
          actions
        }
      })
    }
    return this
  }

  /** Removes the fixed with cols, useful for few columns with short header texts */
  all_autoWidth(custom) {
    this._headers.forEach(h => {
      delete h.width
    })
    return this.all_adapt(custom)
  }

  all_adapt(custom) {
    if (custom) {
      this._headers = this._headers.map(h => {
        return {
          ...h,
          ...custom
        }
      })
    }
    return this
  }

}

export const InstrumentHeaderBuilder = class InstrumentHeaderBuilder extends HeaderBuilder {
  //TODO ShareHeaderbuilder

  // showAs values: "link"/"dialog"/undefined/null/false
  nameWithIsin(showInstrumentProfileAs, custom) {
    this._headers.push({
      text: 'Name + ISIN',
      sortable: true,
      class: 'nameWithIsin',
      sort: (a, b) => a.title.localeCompare(b.title),
      sortKey: this.propPath('name'),
      keywordSort: true,
      value: this.propPath(),
      width: 120,
      ...custom,
      component: showInstrumentProfileAs === "link" ? InstrumentNameCellToDetailPage :
        showInstrumentProfileAs === "dialog" ? InstrumentNameCellToDetailDialog : InstrumentNameCellToDetailPage,
      dynamicModel: (instr) => ({
        title: instr.name,
        subTitle: instr.isin,
        id: instr.id,
        color: AssetClassFinder.findById(instr.assetClass)?.color,
        assetClass: instr.assetClass,
        to: {
          name: instr.assetClass === 'SHARE' ? 'companyDetail' : 'etfDetail',
          params: {id: instr.id}
        }
      }),
      dynamicModelKey: 'col_nameWithIsin'
    })
    return this
  }

  nameWithIsinAndSector(showInstrumentProfileAs) {
    this._headers.push({
      text: 'Name + ISIN + Sektor',
      sortable: true,
      class: 'nameWithIsin',
      sort: (a, b) => a.title.localeCompare(b.title),
      sortKey: this.propPath('name'),
      keywordSort: true,
      value: this.propPath(),
      width: 120,
      component: showInstrumentProfileAs === "link" ? InstrumentNameCellToDetailPage :
        showInstrumentProfileAs === "dialog" ? InstrumentNameCellToDetailDialog : InstrumentNameCellToDetailPage,
      dynamicModel: (instr) => ({
        title: instr.name,
        subTitle: instr.isin + " " + instr.sector.name,
        id: instr.id,
        color: AssetClassFinder.findById(instr.assetClass)?.color,
        assetClass: instr.assetClass,
        to: {
          name: instr.assetClass === 'SHARE' ? 'companyDetail' : 'etfDetail',
          params: {id: instr.id}
        }
      }),
      dynamicModelKey: 'col_nameWithIsin'
    })
    return this
  }

  close(custom) {
    this._headers.push({
      text: 'Akt. Kurs',
      sort: (a, b) => a.value - b.value,
      sortKey: this.propPath('close'),
      align: 'right',
      width: 86,
      value: this.propPath(),
      component: InstrumentCurrencyCell,
      dynamicModel: (instr) => ({
        value: instr.close,
        date: instr.closeDate,
      }),
      dynamicModelKey: 'col_close',
      ...custom,
    })
    return this
  }

  latestPrice_PriceExchange() {
    this._headers.push({
      text: 'Akt. Kurs',
      sortable: false,
      align: 'right',
      width: 86,
      value: this.propPath(),
      component: InstrumentCurrencyCell,
      dynamicModel: (instr) => {
        return {
          value: instr.latestPrice.price,
          date: instr.latestPrice.timestamp,
          datePrefix: `Börse ${instr.latestPrice.exchangeName}: `
        }
      },
      dynamicModelKey: 'col_latestPrice_PriceExchange'
    })
    return this
  }

  latestPrice_Price(withoutDate, custom) {
    this._headers.push({
      text: 'Akt. Kurs',
      sortable: false,
      align: 'right',
      width: 86,
      value: this.propPath(),
      component: InstrumentCurrencyCell,
      componentProps: {
        withoutDate
      },
      dynamicModel: (instr) => {
        let latestPrice = instr.latestPrice
        if (latestPrice) {
          return {
            value: instr.latestPrice.price,
            date: instr.latestPrice.timestamp
          }
        } else {
          return {
            value: instr.close,
            date: instr.closeDate
          }
        }
      },
      dynamicModelKey: 'col_latestPrice_Price',
      ...custom,
    })
    return this
  }

  latestPrice_High() {
    this._headers.push({
      text: 'Tageshoch',
      sortable: false,
      align: 'right',
      value: this.propPath(),
      component: InstrumentCurrencyCell,
      dynamicModel: (instr) => {
        let val = {}

        if (instr.latestPrice.high) {
          val.value = instr.latestPrice.high
        } else {
          val.value = instr.high
        }

        return val
      },
      dynamicModelKey: 'col_latestPrice_High'
    })
    return this
  }

  latestPrice_Low() {
    this._headers.push({
      text: 'Tagestief',
      sortable: false,
      align: 'right',
      value: this.propPath(),
      component: InstrumentCurrencyCell,
      dynamicModel: (instr) => {
        let val = {}

        if (instr.latestPrice.low) {
          val.value = instr.latestPrice.low
        } else {
          val.value = instr.low
        }

        return val
      },
      dynamicModelKey: 'col_latestPrice_Low'
    })
    return this
  }

  currentValue() {
    //TODO realtime and own component
    return this.createCurrencyValue('Aktueller Wert', null, {
      dynamicModel: (instr) => {
        let exchangeName = instr?.latestPrice?.exchangeName
        if (exchangeName) {
          exchangeName = `Börse ${exchangeName}: `
        }
        return {
          value: instr.close,
          date: instr.closeDate,
          datePrefix: exchangeName
        }
      },
      sortKey: this.propPath('close'),
    })
  }

  /** Displays the close change to 1D as percentage */
  closeChange1D() {
    return this.createPercentageChange('G/V Vortag', 'closeChange1D')
  }

  latestPrice_closeChange1D() {
    return this.createPercentageChange('Diff. Vortag', null, {
      dynamicModel: (instrument) => {
        let result
        const latestPrice = instrument.latestPrice

        result = ((latestPrice.price - instrument.close) / instrument.close) * 100
        return result
      }
    })
  }

  closeChange1DWithAbsolut(multiline) {
    return this.createAbsoluteAndPercentage('Differenz Vortag', null, {
      sortKey: this.propPath('closeChange1D'),
      sort: (a, b) => a.percentage - b.percentage,
      dynamicModel: (instrument) => {
        const latestPrice = instrument.latestPrice
        if (latestPrice &&
          latestPrice.priceChange !== undefined &&
          latestPrice.priceChangePercentage !== undefined) {
          return {
            absolute: latestPrice.priceChange,
            percentage: latestPrice.priceChangePercentage,
          }
        } else {
          return {
            absolute: instrument.closeChangeAbsolute1D,
            percentage: instrument.closeChange1D,
          }
        }
      },
      componentProps: {
        multiline: multiline
      },
    })
  }

  closeChange1W() {
    return this.createPercentageChange('G/V Woche', 'closeChange1W')
  }

  closeChange1M() {
    return this.createPercentageChange('G/V Monat', 'closeChange1M')
  }

  closeChange3M() {
    return this.createPercentageChange('G/V 3 Wochen', 'closeChange3M')
  }

  closeChange6M() {
    return this.createPercentageChange('G/V 6 Monate', 'closeChange6M')
  }

  closeChangeYTD() {
    return this.createPercentageChange('G/V laufendes Jahr', 'closeChangeYTD')
  }

  closeChange1Y() {
    return this.createPercentageChange('G/V 1 Jahr', 'closeChange1Y')
  }

  closeChange3Y() {
    return this.createPercentageChange('G/V 3 Jahre', 'closeChange3Y')
  }

  closeChange5Y() {
    return this.createPercentageChange('G/V 5 Jahre', 'closeChange5Y')
  }

  closeChange10Y() {
    return this.createPercentageChange('G/V 10 Jahre', 'closeChange10Y')
  }

  country() {
    return this.createCountryFlag('Land', 'country', {autoCol: true})
  }

  currency() {
    return this.createTextValue('Fondwährung', 'currency')
  }

  dividendYield() {
    return this.createPercentageChange('Div. Rendite', 'dividendYield', {
      hint: HINTS.CURRENTBUSINESSYEARESTIMATE,
      class: 'dividendYield'
    })
  }

  epsGrowth1Y() {
    return this.createPercentageChange('Gewinnwachstum (1 J)', 'epsGrowth1Y')
  }

  evEBITDARatio() {
    return this.createRatio('EV/ EBITDA', 'evEBITDARatio')
  }

  evRevenueRatio() {
    return this.createRatio('EV/ Umsatz', 'evRevenueRatio')
  }

  ebitMargin() {
    return this.createPercentageChange('EBIT Marge', 'ebitMargin')
  }

  finScore(custom) {
    return this.createRanking('finScore', 'finScore', {class: 'finScore', autoCol: true, ...custom})
  }

  high() {
    return this.createCurrencyValue('Tageshoch', 'high')
  }

  isin() {
    return this.createTextValue('Isin', 'isin')
  }

  low() {
    return this.createCurrencyValue('Tagestief', 'low')
  }

  marketCapital() {
    return this.createCurrencyValue('Marktkapitalisierung', 'marketCapital', {
      sortKey: this.propPath('marketCapital'),
      dynamicModel: (val) => val * 1000000
    })
  }

  sector() {
    this._headers.push({
      text: 'Sector',
      sortable: true,
      keywordSort: true,
      value: this.propPath('sector.name'),
    })
    return this
  }

  sectorSustainability() {
    this._headers.push({
      text: 'Nachhaltigkeitsfokus',
      sortable: true,
      keywordSort: true,
      value: this.propPath('sectorSustainability.name'),
    })
    return this
  }

  sectorExclusion() {
    this._headers.push({
      text: 'Ausschlußkriterium',
      sortable: true,
      keywordSort: true,
      value: this.propPath('sectorExclusion.name'),
    })
    return this
  }

  strategy() {
    return this.createTextValue('Strategy', 'strategy')
  }

  latestPrice_Open() {
    return this.createCurrencyValue('Eröffnung', 'latestPrice.open')
  }

  open() {
    return this.createCurrencyValue('Eröffnung', 'open')
  }

  pBVRatio() {
    return this.createRatio('Kurs/ Buchwert', 'pBVRatio')
  }

  pcfRatio() {
    return this.createRatio('Kurs/ Cashflow', 'pcfRatio')
  }

  peRatio() {
    return this.createRatio('KGV', 'peRatio', {hint: HINTS.CURRENTBUSINESSYEAR, class: 'peRatio'})
  }

  peRatioEstimated() {
    return this.createRatio('KGV', 'peRatioEstimated', {hint: HINTS.CURRENTBUSINESSYEARESTIMATE, class: 'peRatio'})
  }

  pRevenueRatio() {
    return this.createRatio('Kurs/ Umsatz', 'pRevenueRatio')
  }

  /* This method is only valid for shares. For ETFs use the method volume in EtfHeaderBuilder.
  * TODO implement ShareHeaderBuilder and move this method there. */
  volume() {
    return this.createCurrencyValue('Volumen', 'volume', {
      sortKey: this.propPath('volume'),
      dynamicModel: (val) => val
    })
  }

  etf(fct) {
    const builder = new EtfHeaderBuilder(this, this.propPath())
    fct(builder)
    return this
  }

  etfCommodity(fct) {
    const builder = new EtfCommoditiesEtfHeaderBuilder(this, this.propPath())
    fct(builder)
    return this
  }

  trailingReturn1Y() {
    return this.createPercentageChange('Rendite annualisiert letztes Jahr', 'trailingReturn1Y')
  }

  trailingReturn3Ypa() {
    return this.createPercentageChange('Rendite annualisiert 3J (p.a.)', 'trailingReturn3Ypa')
  }

  trailingReturn5Ypa() {
    return this.createPercentageChange('Rendite annualisiert 5J (p.a.)', 'trailingReturn5Ypa')
  }

  trailingReturn10Ypa() {
    return this.createPercentageChange('Rendite annualisiert 10J (p.a.)', 'trailingReturn10Ypa')
  }

  trailingReturnYTD() {
    return this.createPercentageChange('Rendite annualisiert laufendes Jahr', 'trailingReturnYTD')
  }
}

export const EtfHeaderBuilder = class etfHeaderBuilderHeaderBuilder extends InstrumentHeaderBuilder {
  alpha3Y() {
    return this.createRatio('Alpha (3 Jahre)', 'alpha3Y')
  }

  averageCreditQuality() {
    return this.createNumberValue('Durchschnittliche Kreditqualität (Bonität)', 'averageCreditQuality')
  }

  averageRemainingTerm() {
    return this.createNumberValue('Durchschnittliche Restlaufzeit (Jahre)', 'averageRemainingTerm')
  }

  averageDuration() {
    return this.createNumberValue('Durchschnittliche Duration (Jahre)', 'averageDuration')
  }

  averageMarketCap() {
    return this.createCurrencyValue('Durchschnittliche Marktkapitalisierung', 'averageMarketCap', {
      sortKey: this.propPath('averageMarketCap'),
      dynamicModel: (val) => val * 1000000
    })
  }

  beta3Y() {
    return this.createRatio('Beta (3 Jahre)', 'beta3Y')
  }

  country() {
    //TODO think about wording? And use instrument impl
    return this.createCountryFlag('Fondsdomizil', 'country')
  }

  cashFlowFrequency() {
    return this.createTextValue('Ausschüttungsintervall', 'cashFlowFrequency', {
      dynamicModel: (val) => CASHFLOWREQUENCIES[val]
    })
  }

  dividendTreatment(displayText, name) {
    return this.createTextValue(name ? name : 'Ausschüttend', 'dividendTreatment', {
      sortKey: this.propPath('dividendTreatment'), //TODO this sortkey should set automaticly
      autoCol: !!displayText,
      paddingTop: displayText ? '5px' : '',
      paddingRight: displayText ? '2px' : '',
      dynamicModel(value) {
        return value === "Distributes" ? (displayText ? 'ausschüttend' : 'Ja')
          : value === "Capitalizes" ? (displayText ? 'thesaurierend' : 'Nein') : 'keine Angaben'
      }
    })
  }

  yield() {
    return this.createPercentageChange('Rendite (Ausschüttung)', 'yield')
  }

  dividend() {
    return this.createCurrencyValue('Betrag der letzten Ausschüttung', 'dividend')
  }

  dividend1Y() {
    return this.createCurrencyValue('Ausschüttung 12 Mon. kummuliert', 'dividend1Y')
  }

  dividendDate() {
    return this.createDateValue('Letzte Ausschüttung', 'dividendDate')
  }

  expenseRatio() {
    return this.createPercentage('TER', 'expenseRatio')
  }

  finScore(size) {
    const componentProps = {
      size: size,
      class: 'finScore'
    }
    return this.createRanking('finScore', 'finScore', {componentProps})
  }

  hedgedFromInto() {
    return this.createTextValue('Währungsgesichert', null, {
      sortKey: this.propPath('hedgedFrom'),
      dynamicModel({hedged, hedgedFrom, hedgedInto}) {
        return hedged === 1 ? `${hedgedFrom} gegen ${hedgedInto}` : 'Nein'
      }
    })
  }

  hedgedFrom() {
    return this.createTextValue('Fondswährung', 'hedgedFrom')
  }

  hedgedInto() {
    return this.createTextValue('Währungsgesichert in', 'hedgedInto')
  }

  issuer() {
    return this.createTextValue('Anbieter', 'issuer')
  }

  indexName(asLink) {
    return asLink
      ? this.createLinkValue('Index', null, {
        sortKey: this.propPath('indexName'),
        dynamicModel: (etf) => ({
          href: etf.fundHomepage,
          text: etf.indexName,
        })
      })
      : this.createTextValue('Index', 'indexName')
  }

  issuerWithBrandName() {
    return this.createTextValue('Anbieter', null, {
      sortKey: this.propPath('issuer'),
      dynamicModel: (etf) => `${etf.issuer} (${etf.brandName})`
    })
  }

  launchDate(shortTitle) {
    return this.createDateValue(shortTitle ? shortTitle : 'Auflagedatum', 'launchDate')
  }

  legalStructure() {
    return this.createTextValue('Rechtliche Struktur', 'legalStructure')
  }

  replicationMethod() {
    return this.createTextValue('Replikationsmethode', 'replicationMethod')
  }

  regionCountry() {
    return this.createTextValue('Region/Land', 'regionCountry')
  }

  sectorTopic() {
    return this.createTextValue('Branche/Thema', 'sectorTopic')
  }

  sizeStyle() {
    return this.createTextValue('Unternehmensgröße', 'sizeStyle')
  }

  volatility3Y() {
    return this.createPercentageChange('Volatilität 3 Jahre', 'volatility3Y')
  }

  /* This method is only valid for the etfs, because of the factor. */
  volume() {
    return this.createCurrencyValue('Volumen', 'volume', {
      sortKey: this.propPath('volume'),
      dynamicModel: (val) => val * 1000000
    })
  }

  yieldRisk3Y() {
    return this.createRatio('Rendite/Risiko (3 Jahre)', 'yieldRisk3Y')
  }

  commodity(fct) {
    const etf = new EtfCommoditiesEtfHeaderBuilder(this, this.propPath())
    fct(etf)
    return this
  }
}

export const EtfCommoditiesEtfHeaderBuilder = class etfCommoditiesHeaderBuilder extends EtfHeaderBuilder {
  category() {
    return this.createTextValue('Kategory', null, {
      sortKey: this.propPath('fundCategory'),
      dynamicModel({fundCategory, fundFocus}) {
        //TODO translate
        return fundCategory + (fundFocus ? ', ' + fundFocus : '')
      }
    })
  }

  fundNiche() {
    return this.createTextValue('Abbildung', 'commodityFundNiche')
  }
}

export const StrategyInstrumentsHeaderBuilder = class strategyInstrumentsHeaderBuilder extends HeaderBuilder {
  constructor(parent, path) {
    super(parent, path)
    this._instrument = new InstrumentHeaderBuilder(this, 'instrument')
  }

  instrument(fct) {
    if (fct) {
      fct(this._instrument)
    }
    return this
  }

  etf(fct) {
    this._instrument.etf(fct)
    return this
  }

  etfCommodity(fct) {
    this._instrument.etfCommodity(fct)
    return this
  }

  finScore() {
    return this.createRanking('finScore', 'finScore', {class: 'finScore', autoCol: true})
  }
}

export const InvoiceHeaderBuilder = class InvoiceHeaderBuilder extends HeaderBuilder {

}

export const TransactionListHeaderBuilder = class TransactionListHeaderBuilder extends HeaderBuilder {

  _titleByTransactionType(transaction) {
    let title

    if (transaction.transaction === 'BUY' || transaction.transaction === 'SELL'
      || transaction.transaction === 'SPLIT' || transaction.transaction === 'DIVIDEND') {
      title = transaction.instrument ? transaction.instrument.name : '-'
    } else if (transaction.transaction === 'CASH_PAY_IN') {
      title = 'Einzahlung'
    } else if (transaction.transaction === 'CASH_PAY_OUT') {
      title = 'Auszahlung'
    }

    return title
  }

  _navigateToByTransactionType(transaction) {
    let to

    if (transaction.instrumentType &&
      (transaction.instrumentType === 'SHARE' || transaction.instrumentType.endsWith('_ETF') ||
        transaction.transaction === 'SPLIT')) {
      to = {
        name: transaction.instrumentType === 'SHARE' ? 'companyDetail' : 'etfDetail',
        params: {id: transaction.instrumentId}
      }
    }

    return to
  }

  type(custom) {
    return this.createIconCell('Typ', 'transaction', {
      ...custom,
      autoCol: true,
      autoColClasses: 'pr-2',
      dynamicModelKey: 'col_taType',
      dynamicModel: (val) => {
        return TRANSACTIONICONS[val]
      }
    })
  }

  nameWithIsin(name, prop) {
    this._headers.push({
      text: name ? name : 'Name',
      sortable: true,
      sort: (a, b) => {
        if (a.title) {
          return b.title ? a.title.localeCompare(b.title) : -1
        } else if (b.title) {
          return a.title ? b.title.localeCompare(a.title) : 1
        }
      },
      sortKey: this.propPath(prop ? prop : 'name'),
      keywordSort: true,
      value: this.propPath(),
      width: 120,
      component: InstrumentNameCellToDetailPage,
      dynamicModel: (transaction) => ({
        title: this._titleByTransactionType(transaction),
        subTitle: transaction.instrument ? transaction.instrument.isin : '',
        to: this._navigateToByTransactionType(transaction),
        color: AssetClassFinder.findById(transaction.instrument?.assetClass)?.color,
        assetClass: transaction.instrument?.assetClass,
      }),
      dynamicModelKey: 'col_nameWithIsin'
    })
    return this
  }

  date(custom) {
    return this.createDateValue('Datum', null, {
      ...custom,
      dynamicModelKey: 'col_taDate',
      dynamicModel: (transaction) => {
        let val
        if (transaction.realizedTimestamp) {
          val = transaction.realizedTimestamp
        } else {
          val = transaction.actionTimestamp
        }
        return val
      }
    })
  }

  count(name, prop, custom) {
    return this.createTextValue(name ? name : 'Stück', prop ? prop : 'count', custom).adapt({
      align: 'right',
      width: 85
    })
  }

  price(name, prop, custom) {
    return this.createCurrencyValue(name ? name : 'Kurs', prop ? prop : null, {
      ...custom,
      dynamicKey: 'col_taPrice',
      sort: (a, b) => b.value - a.value,
      dynamicModel: (transaction) => {
        let val
        if (transaction.realizedPrice) {
          val = transaction.realizedPrice
        } else {
          val = transaction.planedPrice
        }
        return {value: val}
      }
    })
  }

  value(custom) {
    return this.createCurrencyValue('Wert', null, {
      dynamicModelKey: 'col_taValue',
      sort: (a, b) => b.value - a.value,
      dynamicModel: (transaction) => {
        let val = null
        let hintMsg = null
        if (transaction.transaction === 'BUY' || transaction.transaction === 'SELL') {
          if (transaction.realizedPrice) {
            val = transaction.count * transaction.realizedPrice
            hintMsg = '(' + transaction.count + ' St. zu ' + currencyFilter(transaction.realizedPrice) + ')'
          } else {
            val = transaction.count * transaction.planedPrice
            hintMsg = '(' + transaction.count + ' St. zu ' + currencyFilter(transaction.planedPrice) + ')'
          }
        } else if (transaction.transaction === 'CASH_PAY_IN' || transaction.transaction ===
          'CASH_PAY_OUT') {
          val = (transaction.transaction === 'CASH_PAY_OUT' ? '-' : '') + transaction.cashAmount
        }
        return {value: val, hint: hintMsg}
      },
      ...custom,
    })
  }

  fees(name, prop, custom) {
    return this.createCurrencyValue(name ? name : 'Gebühr', prop ? prop : null, {
      ...custom,
      dynamicModelKey: 'col_taFees',
      sort: (a, b) => b.value - a.value,
      dynamicModel: (transaction => {
        let val
        if (transaction.realizedFees || transaction.realizedFees === 0) {
          val = transaction.realizedFees
        } else {
          val = transaction.planedFees
        }
        return {value: val}
      })
    })
  }

  split(name, prop, custom) {
    return this.createTextValue(name ? name : 'Verhältnis neu / alt', null, {
      ...custom,
      dynamicModelKey: 'col_taSplit',
      dynamicModel: (transaction => {
        let split = transaction.split

        if (split) {
          split += ' für 1'
        } else {
          split = '-'
        }

        return split
      })
    }).adapt({
      align: 'right',
      width: 50
    })
  }

  dividendPerShare(name, prop, custom) {
    return this.createCurrencyValue(name ? name : 'Dividende pro Anteil', prop ? prop : 'dps', custom)
  }

  dividendTotal(custom) {
    return this.createCurrencyValue('Dividende gesamt', null, {
      ...custom,
      sort: (a, b) => b.value - a.value,
      dynamicModelKey: 'col_taDividendTotal',
      dynamicModel: (transaction) => {
        let val = null
        let hintMsg = null
        if (transaction.transaction === 'DIVIDEND') {
          val = transaction.count * transaction.dps
          hintMsg = '(' + currencyFilter(transaction.dps) + ' x ' + transaction.count + ' St.)'
        }
        return {value: val, hint: hintMsg}
      }
    })
  }

  sellStatus(custom) {
    return this.createTextValue('Status', null, {
      ...custom,
      dynamicModelKey: 'col_taStatus',
      dynamicModel: (transaction => {
        if (transaction.transaction !== 'BUY') {
          return '-'
        }

        const status = transaction.sellStatus
        let statusMsg = 'Offen'

        if (status === 'PARTIALLY_SOLD') {
          statusMsg = 'Teilverkauft'
        } else if (status === 'SOLD') {
          statusMsg = 'Verkauft'
        }

        return statusMsg
      })
    }).adapt({
      align: 'center',
    })
  }

  earningsLoss(name, prop, custom) {
    //FINDEV-2903
    return this.createCurrencyValue(name ? name : 'G/V Buch', null, {
      dynamicModelKey: 'col_el',
      dynamicModel: ({
                       instrument,
                       count,
                       planedPrice,
                       realizedPrice,
                       planedFees,
                       realizedFees,
                       openCount,
                       transaction
                     }) => {
        if (transaction === 'BUY') {
          const price = instrument.latestPrice.price
          return (price * openCount) - ((realizedPrice || planedPrice) * openCount) - (realizedFees || planedFees) *
            openCount / count
        }
        return null
      },
      ...custom
    })
  }

  earningsLossRealized(custom) {
    //FINDEV-2904
    return this.createCurrencyValue('G/V real.', null, {
      ...custom,
      dynamicModelKey: 'col_elR',
      dynamicModel: ({cashAmount, invest, investFees, transaction}) => {
        if (transaction === 'SELL') {
          return cashAmount - invest - investFees
        }
        return null
      },
    })
  }

  payDate(name, prop, custom) {
    return this.createDateValue(name ? name : 'Auszahlungs-Datum', prop ? prop : 'payDate', custom)
  }
}

export const WatchlistHeaderBuilder = class WatchlistHeaderBuilder extends HeaderBuilder {
  constructor(parent, path) {
    super(parent, path)
    this._instrument = new InstrumentHeaderBuilder(this, 'instrument')
  }

  instrument(fct) {
    if (fct) {
      fct(this._instrument)
    }
    return this
  }

  /** Displays the lowerLimit as currency + notification bell if current close < lowerLimit */
  limitLow() {
    return this.createCurrencyValue('Unteres Limit', null, {
      sort: (a, b) => a.value - b.value,
      dynamicModel: (wlEntry) => {
        let newVal = {
          value: wlEntry.lowerLimit,
        }

        if (wlEntry.lowerLimit && wlEntry.instrument.latestPrice.price < wlEntry.lowerLimit) {
          newVal.icon = {
            color: '#e84b3d',
            name: 'icon-notification-filled',
          }
        }

        return newVal
      }
    })
  }

  /** Displays the upperLimit as currency + notification bell if current close > upperLimit */
  limitHigh() {
    return this.createCurrencyValue('Oberes Limit', null, {
      sort: (a, b) => a.value - b.value,
      dynamicModel: (wlEntry) => {
        let newVal = {
          value: wlEntry.upperLimit,
        }

        if (wlEntry.upperLimit && wlEntry.instrument.latestPrice.price > wlEntry.upperLimit) {
          newVal.icon = {
            color: '#e84b3d',
            name: 'icon-notification-filled',
          }
        }

        return newVal
      }
    })
  }
}

export const PortfolioHeaderBuilder = class PortfolioHeaderBuilder extends HeaderBuilder {
  constructor(parent, path) {
    super(parent, path)
    this._instrument = new InstrumentHeaderBuilder(this, 'instrument')
  }

  instrument(fct) {
    if (fct) {
      fct(this._instrument)
    }
    return this
  }

  /** Displays the average price as currency */
  averagePrice(custom) {
    return this.createCurrencyValue('Kaufkurs', 'averagePrice', custom)
  }

  /** Displays the number of instruments */
  count(formatNumber = false, custom) {
    if (formatNumber) {
      return this.createNumberValue('Stück', 'count', custom)
    } else {
      this._headers.push({
        text: 'Stück',
        align: 'center',
        sortable: true,
        value: this.propPath('count'),
        width: 1,
        ...custom
      })
      return this
    }
  }

  /** Displays the current value as currency */
  currentWPValue(custom) {
    return this.createCurrencyValue('Akt. Wert', null, {
      dynamicModelKey: 'col_currentWPValue',
      dynamicModel: (portfolioEntry) => {
        return portfolioEntry.instrument.latestPrice.price * portfolioEntry.count
      },
      ...custom
    })
  }

  /** Displays the price total as currency */
  purchasePriceTotal() {
    return this.createCurrencyValue('Kaufwert', null, {
      dynamicModelKey: 'col_purchasePriceTotal',
      dynamicModel: (portfolioEntry) => {
        return portfolioEntry.averagePrice * portfolioEntry.count
      }
    })
  }

  growthRate(custom) {
    return this.createPercentageChange('Diff. seit Kauf', null, {
      dynamicModelKey: 'col_growthRate',
      dynamicModel: (portfolioEntry) => {
        let result = (portfolioEntry.instrument.latestPrice.price / portfolioEntry.averagePrice - 1) * 100
        return result
      },
      ...custom
    })
  }

  growthRateWithAbsoluteValue() {
    return this.createAbsoluteAndPercentage('Diff. seit Kauf', null, {
      sortKey: this.propPath('closeChange1D'),
      dynamicModelKey: 'col_growthRate',
      sortable: true,
      sort: (a, b) => {
        return a.percentage - b.percentage
      },
      dynamicModel: (portfolioEntry) => {
        let absoluteValue = portfolioEntry.instrument.latestPrice.price - portfolioEntry.averagePrice
        let percentageValue = (portfolioEntry.instrument.latestPrice.price / portfolioEntry.averagePrice - 1) * 100
        return {
          absolute: absoluteValue * portfolioEntry.count,
          percentage: percentageValue,
        }
      }
    })
  }

  finScore(custom) {
    return this.createRanking('finScore', 'finScore', custom)
  }

  buyDate() {
    return this.createDateValue('Kaufdatum', 'dateAdded')
  }
}

export const KeyFiguresHeaderBuilder = class KeyFiguresHeaderBuilder extends HeaderBuilder {

  dynamicCol(header, custom) {
    if (header) {
      this._headers.push({
        align: header.prop === 'kf' ? 'left' : 'right',
        text: header.prop === 'growth' ? 'Wachstum ' + header.info : header.label,
        textAlign: header.prop === 'kf' ? 'left' : 'right',
        textSup: header.sup,
        mobileHeaderAsTooltip: header.prop === 'growth',
        value: null,
        width: 1,
        sortable: false,
        component: DynamicRendererCell,
        dynamicModelKey: 'kf_col_' + header.prop,
        dynamicModel: (item => {
          const col = item.cols ? item.cols.find(c => c.n === header.prop) : null
          let value = col ? col.v : '-'
          let type = item.financialDataItem.unit

          if (header.prop === 'kf') {
            type = 'TEXT'
            value = item.financialDataItem ? item.financialDataItem.name : item.id
          } else if (header.prop === 'growth') {
            type = 'PERCENT'
          }

          return {value, type, useLexicon: header.prop === 'kf'}
        }),
        ...custom
      })
      return this
    }
  }
}

const detailList = function (headers) {
  return {
    list: {
      headers: headers.map(header => {
        return {
          ...header,
          class: 'detailList'
        }
      }),
      conf: {
        rowProps: {
          style: 'box-shadow: inset 0 -1px 0 0 var(--light-sky-blue);'
        }
      }
    }
  }
}

const inline = function (headers) {
  return {
    grid: {
      headers: headers,
      conf: {
        cols: 'auto',
        inline: true
      }
    }
  }
}

export const TablePresets = {

  createShareScreenerHeaders(items) {
    //TODO adapt can removed after change to new backend api
    const primary = new InstrumentHeaderBuilder().nameWithIsin("link").country().adapt({sortKey: 'countryCode'}).get()
    const secondary = new InstrumentHeaderBuilder().latestPrice_Price().createByItems(items).get()
    const secondaryMobile = new InstrumentHeaderBuilder().latestPrice_Price(true).createByItems(items).get()
    const mobileView = {
      title: primary,
      grid: {
        headers: secondaryMobile,
        conf: {
          cols: (vm) => vm.$valueByBreakpoint({xs: 3, sm: 3})
        }
      },
    }
    return new InstrumentHeaderBuilder().add(primary).add(secondary).createSpacer().get(mobileView)
  },

  // TODO
  createEtfScreenerHeaders(items, hideLexiconHeaders = false) {
    const primary = new EtfHeaderBuilder().nameWithIsin("link").adaptAll({textHideLexicon: hideLexiconHeaders}).get()
    const secondary = new EtfHeaderBuilder().createByItems(items).adaptAll({textHideLexicon: hideLexiconHeaders}).get()

    const mobileView = {
      title: primary,
      grid: {
        headers: secondary, // secondaryMobile same as secondary
        conf: {
          cols: (vm) => vm.$valueByBreakpoint({xs: 3, sm: 3})
        }
      },
    }
    return new EtfHeaderBuilder().add(primary).add(secondary).createSpacer().get(mobileView)
  },

  createShareHeaders(items) {
    //TODO adapt can removed after change to new backend api
    const primary = new InstrumentHeaderBuilder().nameWithIsin("link").country().adapt({sortKey: 'countryCode'}).get()
    const secondary = new InstrumentHeaderBuilder().latestPrice_Price().createByItems(items).get()
    const mobileView = {
      title: primary,
      list: secondary,
    }
    return new InstrumentHeaderBuilder().add(primary).add(secondary).createSpacer().get(mobileView)
  },

  createEtfHeaders(items) {
    const primary = new InstrumentHeaderBuilder().nameWithIsin("link").get()
    const secondary = new InstrumentHeaderBuilder().latestPrice_Price().createByItems(items).get()
    const mobileView = {
      title: primary,
      list: secondary,
    }
    return new InstrumentHeaderBuilder().add(primary).add(secondary).createSpacer().get(mobileView)
  },

  createProfileGrowthHeaders() {
    const primary = new InstrumentHeaderBuilder()
      .closeChange1W().adapt({text: '1 Woche'})
      .closeChange1M().adapt({text: '1 Monat'})
      .closeChange3M().adapt({text: '3 Monate'})
      .closeChange6M().adapt({text: '6 Monate'})
      .closeChangeYTD().adapt({text: 'Laufendes Jahr'})
      .get()

    return new HeaderBuilder().add(primary).get(detailList(primary))
  },

  createProfileRenditeHeaders() {
    const primary = new InstrumentHeaderBuilder()
      .trailingReturn1Y().adapt({text: '1 Jahr'})
      .trailingReturn3Ypa().adapt({text: '3 Jahre'})
      .trailingReturn5Ypa().adapt({text: '5 Jahre'})
      .trailingReturn10Ypa().adapt({text: '10 Jahre'})
      .get()

    return new HeaderBuilder().add(primary).get(detailList(primary))
  },

  createProfileLongTermGrowthHeaders() {
    const primary = new InstrumentHeaderBuilder()
      .closeChange1Y().adapt({text: '1 Jahr'})
      .closeChange3Y().adapt({text: '3 Jahre'})
      .closeChange5Y().adapt({text: '5 Jahre'})
      .closeChange10Y().adapt({text: '10 Jahre'})
      .get()

    return new HeaderBuilder().add(primary).get(detailList(primary))
  },

  createEtfProfilePortfolioDataHeaders({assetClass}) {
    const builder = new EtfHeaderBuilder()

    if (assetClass === 'SHARE_ETF') {
      builder.sectorTopic().regionCountry().strategy().sizeStyle().averageMarketCap()
    } else if (assetClass === 'COMMODITIES_ETF') {
      builder.commodity(c => c.category().fundNiche())
    } else {
      builder.regionCountry().averageCreditQuality().averageRemainingTerm().averageDuration()
    }

    const primary = builder.get()
    return new HeaderBuilder().add(primary).get(detailList(primary))
  },

  createEtfProfileBaseDataHeaders() {
    const primary = new EtfHeaderBuilder().issuerWithBrandName().volume().country().currency().legalStructure().launchDate().replicationMethod().get()
    const mobileView = {
      grid: {
        headers: primary,
        conf: {
          cols: (vm) => vm.$valueByBreakpoint({xs: 12, lg: 6, xl: 4})
        }
      }
    }

    return new HeaderBuilder().add(primary).get(mobileView)
  },

  createEtfProfileRiskHeaders() {
    const primary = new EtfHeaderBuilder().hedgedFromInto().volatility3Y().beta3Y().alpha3Y().yieldRisk3Y().get()
    return new HeaderBuilder().add(primary).get(detailList(primary))
  },

  createEtfProfileDividendHeaders() {
    const primary = new EtfHeaderBuilder().dividendTreatment(true, 'Ertragsverwendung').cashFlowFrequency().dividend1Y().dividendDate().dividend().yield().get()
    return new HeaderBuilder().add(primary).get({
      grid: {
        headers: primary.slice(0, 2),
        conf: {
          cols: '6'
        }
      },
      ...detailList(primary.slice(2))
    })
  },

  createShareDetailPageSubtitle() {
    const primary = new InstrumentHeaderBuilder().isin().get()
    return new HeaderBuilder().add(primary).get(inline(primary))
  },

  createEtfDetailPageSubtitle() {
    const primary = new EtfHeaderBuilder().isin().adapt({class: 'pr-8'}).indexName(true).get()
    return new HeaderBuilder().add(primary).get(inline(primary))
  },

  createShareDetailPageCurrentValue() {
    const primary = new InstrumentHeaderBuilder()
      .latestPrice_PriceExchange()
      .closeChange1DWithAbsolut
      .get()

    const mobileView = {
      grid: {
        headers: primary,
        conf: {
          cols: '12'
        }
      }
    }

    return new HeaderBuilder().add(primary).get(mobileView)
  },

  createShareDetailPageKeyFigures() {
    const primary = new InstrumentHeaderBuilder()
      .peRatioEstimated().adapt({class: 'px-8'})
      .dividendYield().adapt({text: 'Dividendenrendite', class: 'px-8'})
      .marketCapital().adapt({class: 'px-8'})
      .get()

    const mobileView = {
      grid: {
        headers: primary,
        conf: {
          cols: (vm) => vm.$valueByBreakpoint({xs: 12, sm: 'auto'})
        }
      }
    }

    return new HeaderBuilder().add(primary).get(mobileView)
  },

  createEtfDetailPageCurrentValue() {
    const primary = new EtfHeaderBuilder()
      .latestPrice_PriceExchange()
      .closeChange1DWithAbsolut
      .get()

    const mobileView = {
      grid: {
        headers: primary,
        conf: {
          cols: '12'
        }
      }
    }

    return new HeaderBuilder().add(primary).get(mobileView)
  },

  createEtfDetailPageKeyFigures() {
    const primary = new EtfHeaderBuilder()
      .finScore(36).adapt({class: 'px-8'})
      .expenseRatio().adapt({text: 'Kosten (TER)', class: 'px-8'})
      .dividendTreatment(true, 'Ertragsverwendung').adapt({class: 'px-8'})
      .get()

    const mobileView = {
      grid: {
        headers: primary,
        conf: {
          cols: (vm) => vm.$valueByBreakpoint({xs: 12, sm: 'auto'})
        }
      }
    }

    return new HeaderBuilder().add(primary).get(mobileView)
  },

  createShareRatingHeaders(actions) {
    const primary = new InstrumentHeaderBuilder().nameWithIsin().country().get()
    const secondary = new InstrumentHeaderBuilder().close().peRatio().pcfRatio().pRevenueRatio().pBVRatio().evEBITDARatio().evRevenueRatio().get()
    const actionsCol = new InstrumentHeaderBuilder().actionsButtons(actions).get()

    const mobileView = {
      title: new InstrumentHeaderBuilder().add(primary).createSpacer().add(actionsCol).get(),
      list: secondary,
    }

    return new InstrumentHeaderBuilder().add(primary).add(secondary).createSpacer().add(actionsCol).get(mobileView)
  },

  createDetailPageDailyDevelopment() {
    const primary = new InstrumentHeaderBuilder()
      .close().adapt({text: 'Vortagesschluss', dynamicModel: (instr) => ({value: instr.close})})
      .latestPrice_Open()
      .latestPrice_High()
      .latestPrice_Low()
      .get()
    return new HeaderBuilder().add(primary).get(detailList(primary))
  },

  createStrategyDataTableHeaders(assetClassId, extended, viewType, showInstrumentProfileAs) {
    // all values to display on desktops
    let desktops = new StrategyInstrumentsHeaderBuilder()
    // all values contained in primary will be displayed on the first line on mobiles
    let mobilePrimary = new StrategyInstrumentsHeaderBuilder()
    // values displayed as grid
    let mobileSecondaryGrid = new StrategyInstrumentsHeaderBuilder()

    if (assetClassId === 'SHARE') {
      if (viewType.title === 'Überblick') {
        // normal view: finScore, Name + ISIN, country, close, sector, KGV, Div. Rendite (lfd. G.-Jahr)
        // extend view: normal view + Gewinnwachstum 1J, EBIT Marge
        desktops = extended ?
          desktops.finScore().instrument(i => i.nameWithIsin(showInstrumentProfileAs).country().latestPrice_Price().sector().sectorSustainability().peRatio().dividendYield().epsGrowth1Y().ebitMargin()) :
          desktops.finScore().instrument(i => i.nameWithIsin(showInstrumentProfileAs).country().latestPrice_Price().sector().sectorSustainability().peRatio().dividendYield())
        mobilePrimary = mobilePrimary.instrument(i => i.nameWithIsinAndSector(showInstrumentProfileAs).country())
        mobileSecondaryGrid = mobileSecondaryGrid.finScore().instrument(i => i.latestPrice_Price(true).peRatio().dividendYield())
      }
    } else if (assetClassId === 'SHARE_ETF' || assetClassId === 'CORPORATE_BONDS_ETF' || assetClassId === 'GOVERNMENT_BONDS_ETF') {
      // normal view: finScore, Name + ISIN, close, Ausschüttend, trailingReturn1Y
      // extend view: normal view + volume, start date,  trailingReturn3Ypa, trailingReturn5Ypa
      desktops = extended ?
        desktops.finScore().etf(i => i.nameWithIsin(showInstrumentProfileAs).latestPrice_Price().volume().launchDate().dividendTreatment().yield().expenseRatio().trailingReturn1Y().trailingReturn3Ypa().trailingReturn5Ypa()) :
        desktops.finScore().etf(i => i.nameWithIsin(showInstrumentProfileAs).latestPrice_Price().dividendTreatment().expenseRatio().trailingReturn1Y())
      mobilePrimary = mobilePrimary.etf(i => i.nameWithIsin(showInstrumentProfileAs).dividendTreatment(true))
      mobileSecondaryGrid = mobileSecondaryGrid.finScore().etf(i => i.latestPrice_Price(true).expenseRatio().launchDate('seit'))
    } else if (assetClassId === 'COMMODITIES_ETF') {
      // normal view: finScore, Name + ISIN, close, trailingReturn1Y
      // extend view: normal view + volume, start date, trailingReturn3Ypa, trailingReturn5Ypa
      desktops = extended ?
        desktops.finScore().etfCommodity(i => i.nameWithIsin(showInstrumentProfileAs).latestPrice_Price().volume().launchDate().expenseRatio().trailingReturn1Y().trailingReturn3Ypa().trailingReturn5Ypa()) :
        desktops.finScore().etfCommodity(i => i.nameWithIsin(showInstrumentProfileAs).latestPrice_Price().expenseRatio().trailingReturn1Y())
      mobilePrimary = mobilePrimary.etfCommodity(i => i.nameWithIsin(showInstrumentProfileAs).dividendTreatment(true))
      mobileSecondaryGrid = mobileSecondaryGrid.finScore().etf(i => i.latestPrice_Price(true).expenseRatio().launchDate('seit'))
    }

    const mobileView = {
      title: mobilePrimary.get(),
      grid: {
        headers: mobileSecondaryGrid.get(),
        conf: {
          cols: (vm) => vm.$valueByBreakpoint({xs: 3, sm: 3})
        }
      }
    }

    return new InstrumentHeaderBuilder().add(desktops.get()).createSpacer().get(mobileView)
  },

  createWatchlistHeaders(actions) {
    const primary = new WatchlistHeaderBuilder().instrument(i => i.nameWithIsin()).get()
    const secondary = new WatchlistHeaderBuilder().instrument(i => i.latestPrice_Price().closeChange1DWithAbsolut(true).latestPrice_Low().latestPrice_High()).limitLow().limitHigh().get()

    const primaryMobile = new WatchlistHeaderBuilder()
      .instrument(i => i.nameWithIsin("link", {autoCol: true}).latestPrice_Price(true, {bold: true})).actionsMenu(actions).get()
    const secondaryMobile = new WatchlistHeaderBuilder()
      .instrument(i => i.latestPrice_Low().latestPrice_High()).limitLow().limitHigh().get()

    const actionsCol = new WatchlistHeaderBuilder().actionsCell().get()

    const mobileView = {
      title: primaryMobile,
      grid: {
        headers: secondaryMobile,
        conf: {
          cols: (vm) => vm.$valueByBreakpoint({xs: 3, sm: 3})
        }
      }
    }

    return new WatchlistHeaderBuilder().add(primary).createSpacer().add(secondary).add(actionsCol).all_autoWidth().get(mobileView)
  },

  createTransactionListHeaders(actions, view) {
    let primary = new TransactionListHeaderBuilder().type().nameWithIsin()

    if (!view || view.id === 'DEFAULT') {
      primary.date().value().dividendTotal()
    } else if (view.id === 'ALL') {
      primary.date().value().fees().sellStatus().split().dividendTotal().earningsLossRealized().earningsLoss()
    } else if (view.id === 'BUYSELL') {
      primary.date().value().fees().sellStatus().earningsLossRealized().earningsLoss()
    } else if (view.id === 'CASHES') {
      primary.date().value()
    } /*else if (view.id === 'SUCCESS') {
      primary.sellStatus().date().dividendTotal().value().fees().earningsLossRealized().earningsLoss()
    } else if (view.id === 'SUCCESS_OPEN') {
      primary.date().dividendTotal().value().earningsLoss()
    } else if (view.id === 'SUCCESS_SOLD') {
      primary.date().value().fees().earningsLoss()
    } */ else if (view.id === 'SPLITS') {
      primary.date().count().split()
    } else if (view.id === 'SELLS') {
      primary.date().value().fees().earningsLossRealized()
    } else if (view.id === 'BUYS') {
      primary.sellStatus().date().value().fees().earningsLoss()
    } else if (view.id === 'DIVIDENDS') {
      primary.date().payDate().count().dividendPerShare().dividendTotal()
    }

    let primaryMobile = new TransactionListHeaderBuilder().type().nameWithIsin().adapt({align: 'left'})
    if (actions.length > 0) {
      primaryMobile = primaryMobile.actionsMenu(actions)
    }

    let secondaryMobile = new TransactionListHeaderBuilder()
    if (!view || view.id === 'DEFAULT') {
      secondaryMobile = secondaryMobile.date({minWidth: '85px'}).value({minWidth: '100px'}).dividendTotal({minWidth: '95px'})
    } else if (view.id === 'ALL') {
      /* not displayed any more on mobiles */
      secondaryMobile = secondaryMobile.date({minWidth: '85px'}).value({minWidth: '100px'}).fees().sellStatus().split({minWidth: '85px'}).dividendTotal({minWidth: '95px'}).earningsLossRealized({minWidth: '95px'}).earningsLoss()
    } else if (view.id === 'BUYS') {
      secondaryMobile = secondaryMobile.date({minWidth: '85px'}).sellStatus().value({minWidth: '100px'}).earningsLoss()
    } else if (view.id === 'SELLS') {
      secondaryMobile = secondaryMobile.date({minWidth: '85px'}).value({minWidth: '100px'}).earningsLossRealized()
    } else if (view.id === 'BUYSELL') {
      /* not displayed any more on mobiles */
      secondaryMobile = secondaryMobile.date({minWidth: '85px'}).sellStatus().value({minWidth: '100px'}).earningsLossRealized({minWidth: '95px'}).earningsLoss()
    } else if (view.id === 'CASHES') {
      secondaryMobile = secondaryMobile.date({minWidth: '85px'}).value({minWidth: '85px'})
    } /* else if (view.id === 'SUCCESS') {
      secondaryMobile = secondaryMobile.sellStatus().value().date().dividendTotal().fees().earningsLossRealized().earningsLoss()
    } else if (view.id === 'SUCCESS_OPEN') {
      secondaryMobile = secondaryMobile.value().date().dividendTotal().earningsLoss()
    } else if (view.id === 'SUCCESS_SOLD') {
      secondaryMobile = secondaryMobile.value().date().price().fees().earningsLoss()
    } */ else if (view.id === 'SPLITS') {
      secondaryMobile = secondaryMobile.date({minWidth: '85px'}).split({minWidth: '85px'})
    } else if (view.id === 'DIVIDENDS') {
      secondaryMobile = secondaryMobile.date({minWidth: '85px'}).payDate({minWidth: '85px'}).dividendTotal({minWidth: '95px'})
    }

    const mobileView = {
      title: primaryMobile.get(),
      grid: {
        headers: secondaryMobile.get(),
        conf: {
          cols: (vm) => vm.$valueByBreakpoint({xs: 3, sm: 3})
        }
      },
    }

    let result = new TransactionListHeaderBuilder().add(primary.get())
    if (actions.length > 0) {
      result = result.createSpacer().actionsMenu(actions)
    }
    result = result.get(mobileView)
    return result
  },

  createReducedPortfolioDetailsHeaders(showInstrumentProfileAs) {
    // all values to display on desktops
    let primary = new PortfolioHeaderBuilder().instrument(i => i.nameWithIsin(showInstrumentProfileAs)).get()
    let secondary = new PortfolioHeaderBuilder().instrument(i => i.latestPrice_Price()).count().currentWPValue()
      .instrument(i => i.latestPrice_closeChange1D()).get()

    // all values contained in primary will be displayed on the first line on mobiles
    let primaryMobile = new PortfolioHeaderBuilder().instrument(i => i.nameWithIsin(showInstrumentProfileAs)).createSpacer().get()

    // values displayed as grid on mobiles
    let secondaryMobileGrid =
      new PortfolioHeaderBuilder().count().currentWPValue().instrument(i => i.latestPrice_Price(true).closeChange1D()).get()

    const mobileView = {
      title: primaryMobile,
      grid: {
        headers: secondaryMobileGrid,
        conf: {
          cols: (vm) => vm.$valueByBreakpoint({xs: 3, sm: 3})
        }
      }
    }

    return new PortfolioHeaderBuilder().add(primary).add(secondary).get(mobileView)
  },

  createPortfolioBacktrackingDataTableHeaders(strategyId) {
    let primary = strategyId !== undefined ?
      new PortfolioHeaderBuilder().instrument(i => i.finScore()).instrument(i => i.nameWithIsin()).get() :
      new PortfolioHeaderBuilder().instrument(i => i.nameWithIsin()).get()
    let secondary =
      new PortfolioHeaderBuilder().buyDate().averagePrice().instrument(i => i.latestPrice_Price()).count(true).purchasePriceTotal()
        .currentWPValue().growthRateWithAbsoluteValue().get()

    // all values contained in primary will be displayed on the first line on mobiles
    let primaryMobile = strategyId !== undefined ?
      new PortfolioHeaderBuilder().instrument(i => i.nameWithIsin().finScore())
        .currentWPValue({bold: true, autoCol: true}).get() :
      new PortfolioHeaderBuilder().instrument(i => i.nameWithIsin())
        .currentWPValue({bold: true, autoCol: true}).get()

    // values displayed as grid on mobiles
    let secondaryMobileGrid =
      new PortfolioHeaderBuilder().count(true).averagePrice().instrument(i => i.latestPrice_Price(true))
        .growthRateWithAbsoluteValue().get()

    const mobileView = {
      title: primaryMobile,
      grid: {
        headers: secondaryMobileGrid,
        conf: {
          cols: (vm) => vm.$valueByBreakpoint({xs: 3, sm: 3})
        }
      }
    }

    return new PortfolioHeaderBuilder().add(primary).add(secondary).get(mobileView)
  },

  createPortfolioDataTableHeaders(strategyId, actions) {
    //TODO just do this pretty
    // init values to display in all situations

    // all values to display on desktops
    let primary = strategyId !== undefined ?
      new PortfolioHeaderBuilder().instrument(i => i.finScore()).instrument(i => i.nameWithIsin()).get() :
      new PortfolioHeaderBuilder().instrument(i => i.nameWithIsin()).get()
    let secondary =
      new PortfolioHeaderBuilder().instrument(i => i.latestPrice_Price()).averagePrice().count().currentWPValue().purchasePriceTotal().instrument(i => i.latestPrice_closeChange1D()).growthRateWithAbsoluteValue().get()

    // all values contained in primary will be displayed on the first line on mobiles
    let primaryMobile = strategyId !== undefined ?
      new PortfolioHeaderBuilder().instrument(i => i.finScore({paddingRight: '4px'}).nameWithIsin()).currentWPValue({
        bold: true,
        autoCol: true
      }).actionsMenu(actions).get() :
      new PortfolioHeaderBuilder().instrument(i => i.nameWithIsin()).currentWPValue({
        bold: true,
        autoCol: true
      }).actionsMenu(actions).get()

    // values displayed as grid on mobiles
    let secondaryMobileGrid =
      new PortfolioHeaderBuilder()
        .count(false, {autoCol: true, minWidth: '40px'})
        .averagePrice({autoCol: true, minWidth: '75px'})
        .instrument(i => i.latestPrice_Price(true, {autoCol: true, minWidth: '75px'}))
        .growthRateWithAbsoluteValue().get()

    const actionsCol = new PortfolioHeaderBuilder().actionsMenu(actions).get()

    const mobileView = {
      title: primaryMobile,
      grid: {
        headers: secondaryMobileGrid,
        conf: {
          cols: (vm) => vm.$valueByBreakpoint({xs: 'auto', sm: 3})
        }
      }
    }


    return new PortfolioHeaderBuilder().add(primary).add(secondary).add(actionsCol).get(mobileView)
  },

  createTableProfile(headers, grid) {
    const primary = new HeaderBuilder().add(headers).get()
    const mobileView = {
      [grid ? 'grid' : 'list']: primary
    }
    return new HeaderBuilder().add(primary).get(mobileView)
  },


  createInvoicesHeaders() {
    const primary = new InvoiceHeaderBuilder()
      .createTextValue('Rechnungsnummer', 'invoiceNumber')
      .createTextValue('Abo', 'abonnement') // TODO
      .createTextValue('Betrag', 'amountDue') // TODO are always EUR so far
      .createTextValue('Währung', 'currency')
      .createDateValue('Rechnung fällig bis', 'dueDate')
      .createTextValue('Rechnungsstatus', 'statusText')
      .createDateValue('Abo von', 'periodStart')
      .createDateValue('Abo bis', 'periodEnd')
      .createDateValue('Rechnung erstellt am', 'created')
      .get()
    const primaryMobile = new InvoiceHeaderBuilder()
      .createTextValue('Abo', 'abonnement') // TODO
      .createTextValue('Betrag', 'amountDue', {autoCol: true}) // TODO are always EUR so far
      .createTextValue('Währung', 'currency', {autoCol: true})
      .get()
    const secondaryMobile = new InvoiceHeaderBuilder()
      .createDateValue('Abo von', 'periodStart', {autoCol: true})
      .createDateValue('Abo bis', 'periodEnd', {autoCol: true})
      .get()

    const mobileView = {
      title: primaryMobile,
      grid: {
        headers: secondaryMobile,
        conf: {
          cols: (vm) => vm.$valueByBreakpoint({xs: 6, sm: 6})
        }
      }
    }

    return new InvoiceHeaderBuilder().add(primary).createSpacer().get(mobileView)
  },

  createShareKeyFiguresTableHeader(figureRows) {
    const headers = [{label: 'Kennzahl', prop: 'kf', sup: null}]

    if (figureRows[0].cols && figureRows[0].cols.length > 0) {
      for (let i = 0; i < figureRows[0].cols.length; i++) {
        const c = figureRows[0].cols[i]

        headers.push({
          label: c.n,
          prop: c.n,
          sup: i === 0 ? null : 2,
          info: c.n === 'growth' ? '(' + figureRows[0].cols[0].n + '/' + figureRows[0].cols[1].n.substring(2) + ')' : null
        })
      }
    }

    let primary = new KeyFiguresHeaderBuilder()

    headers.forEach(h => {
      primary.dynamicCol(h)
    })

    primary = primary.get()

    // show key figure name + growth at first row
    let primaryMobile = new KeyFiguresHeaderBuilder().dynamicCol(headers[0])
    if (headers.length > 0) {
      primaryMobile.dynamicCol(headers.find(h => h.label === 'growth'), {
        autoCol: true,
        autoColClasses: 'pl-2'
      })
    }
    primaryMobile = primaryMobile.get()
    // show 4 years at second row
    const secondaryMobileGrid = new KeyFiguresHeaderBuilder()

    const headerOnlyYears = headers.filter(h => (h.prop !== 'kf' && h.prop !== 'growth'))
    headerOnlyYears.forEach(h => {
      secondaryMobileGrid.dynamicCol(h)
    })

    const mobileView = {
      title: primaryMobile,
      grid: {
        headers: secondaryMobileGrid.get(),
        conf: {
          cols: (vm) => vm.$valueByBreakpoint({xs: 3, sm: 3})
        }
      }
    }

    return new KeyFiguresHeaderBuilder().add(primary).get(mobileView)
  }
}
